import React from "react";
import "./popup.scss";

const Popup = ({children,onClick }) => {
  return (
    <>
      <section id="popup-wrapper">
        <div className="popup">
          <div className="icon">
            <div className="popup-icon" onClick={onClick} >
              <span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="9"
                  height="9"
                  viewBox="0 0 9 9"
                  fill="none"
                >
                  <g clip-path="url(#clip0_493_300)">
                    <path
                      d="M8.77409 8.77296C8.61974 8.92425 8.41223 9.00899 8.19611 9.00899C7.97998 9.00899 7.77247 8.92425 7.61812 8.77296L4.50115 5.65599L1.38418 8.77296C1.22983 8.92425 1.02232 9.00899 0.806198 9.00899C0.590072 9.00899 0.382561 8.92425 0.228216 8.77296C0.076928 8.61862 -0.0078125 8.4111 -0.0078125 8.19498C-0.0078125 7.97885 0.076928 7.77134 0.228216 7.617L3.34519 4.50002L0.228216 1.40369C0.076928 1.24935 -0.0078125 1.04184 -0.0078125 0.82571C-0.0078125 0.609584 0.076928 0.402074 0.228216 0.247729C0.303007 0.169771 0.392724 0.107665 0.492021 0.0651088C0.591319 0.0225527 0.698166 0.00041766 0.806198 2.22464e-05C0.914414 -0.000792746 1.02163 0.0207933 1.1211 0.0634229C1.22057 0.106053 1.31014 0.168803 1.38418 0.247729L4.50115 3.3647L7.61812 0.247729C7.69317 0.170324 7.78301 0.108782 7.88229 0.066755C7.98158 0.024728 8.08829 0.003072 8.19611 0.003072C8.30392 0.003072 8.41064 0.024728 8.50992 0.066755C8.60921 0.108782 8.69904 0.170324 8.77409 0.247729C8.9169 0.406765 8.99753 0.611995 9.00115 0.82571C8.99753 1.03943 8.9169 1.24466 8.77409 1.40369L5.65712 4.50002L8.77409 7.617C8.92538 7.77134 9.01012 7.97885 9.01012 8.19498C9.01012 8.4111 8.92538 8.61862 8.77409 8.77296Z"
                      fill="white"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_493_300">
                      <rect width="9" height="9" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </span>
            </div>
          </div>
          {children}
        </div>
      </section>
    </>
  );
};

export default Popup;
